import React, {useEffect, useState} from 'react';
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from '@mui/material';
import {EntityType, FormData} from '../types';
import {getRepositorySingularFromTitle} from '../common/util';

interface DialogProps {
	open: boolean;
	onClose: () => void;
	onSubmit: (formData: FormData) => void;
}

interface RepositoryFormValues {
	title: string;
}

const getInitialValues = (): RepositoryFormValues => ({
	title: '',
});

const AddRepositoryDialog: React.FC<DialogProps> = ({
	open,
	onClose,
	onSubmit,
}) => {
	const [values, setValues] = useState<RepositoryFormValues>(getInitialValues);

	useEffect(() => {
		if (open) {
			setValues(getInitialValues());
		}
	}, [open]);

	const handleChange = (patch: Partial<RepositoryFormValues>) => {
		setValues((prev) => ({
			...prev,
			...patch,
		}));
	};

	const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const nextTitle = event.target.value;
		handleChange({
			title: nextTitle,
		});
	};

	const handleDialogClose = () => {
		setValues(getInitialValues());
		onClose();
	};

	const handleSubmit = (event: React.FormEvent) => {
		event.preventDefault();

		const title = values.title.trim();

		if (!title) {
			return;
		}

		const singular = getRepositorySingularFromTitle(title);

		const payload: FormData = {
			type: EntityType.Repository,
			title,
			singular,
		};

		onSubmit(payload);
	};

	return (
		<Dialog
			open={open}
			onClose={handleDialogClose}
			maxWidth='xs'
			fullWidth
		>
			<DialogTitle>New collection</DialogTitle>
			<form onSubmit={handleSubmit} autoComplete='off'>
				<DialogContent>
					<Box display='flex' flexDirection='column' gap={2} mt={1}>
						<TextField
							label='Title'
							value={values.title}
							onChange={handleTitleChange}
							variant='standard'
							fullWidth
							required
							autoFocus
							placeholder='e.g. cake ingredients'
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleDialogClose}>
						Cancel
					</Button>
					<Button type='submit' variant='contained'>
						Create
					</Button>
				</DialogActions>
			</form>
		</Dialog>
	);
};

export default AddRepositoryDialog;

